import appFeatures from 'effective-features!';
import rootTemplate from 'text!portal/views/root.html';
import faqConfig from 'text!portal/config/faq.json';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';
import 'angularRouter';
import AuthConfigUtil from 'gw-portals-auth-js/utils/AuthConfigUtil';
import GetXcenterEntryPoint from 'gw-portals-platform-js/entryPoint/GetXcenterEntryPoint';

// Connects to localhost by default.
// Options: 'http://uxui-dev.guidewire.com'
var HOST_RUN_TIME = /* hostRunTime_START*/'' /* hostRunTime_END*/;

// Flag to separate /app (Dev) and distribution builds
var IS_DISTRIBUTION_BUILD = /* DISTRIBUTION_BUILD_START*/true /* DISTRIBUTION_BUILD_END*/;
var IS_PRODUCTION_BUILD = /* PRODUCTION_BUILD_START*/true /* PRODUCTION_BUILD_END*/;

/**
 * Module used to define application level configuration parameters that should be
 * passed to capability modules
 */

export default angular.module('portal.config', ['ui.router'])

/**
 * Defines the prefix url where the set of states for a sub module should
 * plug into the portal application
 */
.constant('state_plugin_config', {
    main_root: 'root',
    billing: 'root',
    fnol: 'root',
    claims: 'root',
    quote_bind: 'root',
    home: 'gatewayLanding',
    endorsement: 'root',
    faq: 'root'
}).constant('httpSettings', {
    'timeout': 90000,
    'reloadQueryParamName': 'goto',
    'reloadURL': '/index.html',
    'serviceBaseURLs': {
        'pc': HOST_RUN_TIME + '/pc/service/edge/',
        'quote': HOST_RUN_TIME + '/quote/',
        'cc': HOST_RUN_TIME + '/cc/service/edge/',
        'bc': HOST_RUN_TIME + '/bc/service/edge/',
        'cm': HOST_RUN_TIME + '/ab/service/edge/',
        'journey': HOST_RUN_TIME + '/journey/',
        'vinlookup': HOST_RUN_TIME + '/vehicleinfo/',
        'availability': HOST_RUN_TIME + '/pc/service/edge/gatewaypolicychange/',
        'propertycode': HOST_RUN_TIME + '/pc/service/edge/gatewaypropertycode/'
    }
}).constant('fnolConfig', {
    firstState: 'policySelect',
    multiplePolicies: true
})

// Used for date of birth dropdowns.
.constant('AgeAllowedToDrive', 16).constant('MaximumAge', 100).constant('maxFileUploadSize', 50000000) // 50MB. Used to specify the maximum file size for document upload.


.constant('defaultLocaleDetails', {
    countryCode: 'US',
    mapCenter: {
        lat: 37.923933,
        lon: -122.5203
    }
}).config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    var states = [{
        name: 'root',
        url: '',
        template: rootTemplate,
        abstract: true,
        resolve: {
            proceedToHomePage: ['oAuth', function (oAuth) {
                var authenticationService = AuthenticationService(oAuth);
                return authenticationService.waitForLoginRequestComplete;
            }]
        }
    }];

    for (var i = 0; i < states.length; i++) {
        $stateProvider.state(states[i]);
    }

    $urlRouterProvider.when('/account-policy-details/{policyNumber}', '/policies/{policyNumber}/summary');
    //DEF-0455 change this from /home to /auth/login to prevent the page to display an empty page.
    $urlRouterProvider.otherwise('/auth/login');
}]).config(['IS_PRODUCTION_BUILD', function (isProduction) {
    if (isProduction) {
        console.log = function () {};
    }
}]).constant('config.supportPhone', '800-555-1212').constant('ASYNC_TRANSLATIONS', true) // Constant that allows us to load translations synchronously (tests/Components Examples)
.constant('ANGULARI18N_PRESET', '') // Constant that allows us to load Angular Locale from different path (Components Examples)
.constant('TRANSLATE_PROVIDER_PREFIX', '') // Constant that allows us to load translations from different path (Components Examples)
.constant('FAQ_CONFIG', JSON.parse(faqConfig)).constant('AGENT_REPORTS', [{
    type: 'growth',
    nameId: 'portal.infocenter.tab.Growth',
    icon: 'edit',
    enabled: true,
    reportUrl: '../styles/images/ic/1.png'
}, {
    type: 'ratios',
    nameId: 'portal.infocenter.tab.Loss Ratios',
    icon: 'bar-chart',
    enabled: true,
    reportUrl: '../styles/images/ic/2.png'
}, {
    type: 'commissions',
    nameId: 'portal.infocenter.tab.Commissions',
    icon: 'usd',
    enabled: false,
    reportUrl: '../styles/images/ic/3.png'
}]).constant('oAuth', function () {
    var clientId = AuthConfigUtil.getPortalClientId('GatewayApplication', IS_DISTRIBUTION_BUILD);
    var portalName = GetXcenterEntryPoint(IS_DISTRIBUTION_BUILD);

    return {
        clientId: clientId,
        refreshRedirectPage: appFeatures.oAuthRedirectHomePage,
        portalName: portalName
    };
}())

/**
*  Updated as part of INC-GPA-0360,  DP- Screen timeout
*  Subject to organizational decision, Inactivity Interval Minutes and Logout Confirmation Interval Minutes parameters can change.
*/
.constant('sessionConfig', {
    inactivityIntervalMins: 120,
    logoutConfirmationIntervalMins: 3
})

/**
*  Subject to organizational decision, serverDownTime and featureEnabled parameters can change.
*/
.constant('serverDown', {
    serverDownTime: '22:00',
    featureEnabled: true
}).constant('INFOCENTER_GPA_REPORT_API_ENDPOINTS', {
    commissions_rest_api: "/rds/reportData/searchPath/content/folder[@name='Guidewire']/folder[@name='Embeddable Widgets']/folder[@name='Producer']/folder[@name='Producer Commissions']/folder[@name='Producer Commission Sources']/report[@name='Producer Commission Data']?fmt=JSON"
}).constant('MSFMedicalDeductibleLink', { 'url': 'https://www.montanastatefund.com/web/workerscompensation/policyoptionsinformation.jsf' }).constant('MSFEnvironmentsNameLookup', {
    'localhost': 'local',
    'stfdevpe.stf.state.mt.us': 'dev',
    'stfdv3pe.stf.state.mt.us': 'dit5',
    'stfint2pe.stf.state.mt.us': 'sit1',
    'stfint3pe.stf.state.mt.us': 'sit2',
    'stfintpe.stf.state.mt.us': 'int',
    'stfqape.stf.state.mt.us': 'qa',
    'stfqa2pe.stf.state.mt.us': 'qa2',
    'stfqa3pe.stf.state.mt.us': 'qa3',
    'pe.montanastatefund.com': 'prod'
}).constant('app4HostName', {
    'local': 'localhost',
    'dev': 'stfdevapp4.stf.state.mt.us',
    'dit5': 'stfdv3app4.stf.state.mt.us',
    'sit1': 'stfint2app4.stf.state.mt.us',
    'sit2': 'stfint3app4.stf.state.mt.us',
    'int': 'stfintapp4.stf.state.mt.us',
    'qa': 'stfqaapp4.stf.state.mt.us',
    'qa2': 'stfqa2app4.stf.state.mt.us',
    'qa3': 'stfqa3app4.stf.state.mt.us',
    'prod': 'www.montanastatefund.com'
}).constant('MSFForgotPasswordLinkPath', '/SecurityCenter/').constant('MSFForgotUsernameLinkPath', '/SecurityCenter/forgotUsername.jsf').constant('MSFConstructionCreditLink', '/web/docs/construction-credit-instructions.pdf').constant('PayNowLink', '/OnlinePayments').constant('IS_PRODUCTION_BUILD', IS_PRODUCTION_BUILD).value('GPA_PC_ENTRY_POINT', GetXcenterEntryPoint(IS_DISTRIBUTION_BUILD) + '/pc/GatewayPortal.do');


//////////////////
// WEBPACK FOOTER
// ./dist/js/portal/config.js
// module id = 8
// module chunks = 0